T.FAQ = Class(
	/**
	 * @lends {T.FAQ#}
	 */
	{
		__construct( par ) {
			par = par || {};

			this.node = mkE({
				tag: 'div',
				className: 'FAQ',
				attr: {
					'itemscope': '',
					'itemtype': 'https://schema.org/FAQPage'
				}
			});

			let content = mkE({
				tag: 'div',
				className: 'faq-content',
				els: [
					{
						tag: 'h2',
						className: 'h1',
						text: par.title
					}
				]
			}).append(this.node);

			if( par.intro ) {
				mkE({
					tag: 'p',
					className: 'intro',
					innerHTML: par.intro
				}).append(content);
			}

			this.accordion = mkE({
				tag: 'div',
				className: 'accordion'
			}).append(content);

			let questionsCount = Number(D.Lang.get(par.prefix + '.questions.count') || 0);
			for( let i = 0; i < questionsCount; i++ ) {
				let textNode = mkE({
					tag: 'div',
					attr: {
						itemprop: 'text'
					},
					text: D.Lang.get(par.prefix + '.answers.' + i)
				});
				mkE({
					tag: 'div',
					className: 'section',
					attr: {
						itemscope: '',
						itemprop: 'mainEntity',
						itemtype: 'https://schema.org/Question'
					},
					id: 'section-' + i,
					els: [
						{
							tag: 'input',
							type: 'checkbox',
							name: 'tab',
							id: 'tab-' + i
						},
						{
							tag: 'label',
							attr: {
								for: 'tab-' + i,
								itemprop: 'name'
							},
							els: [
								{
									tag: 'h3',
									text: D.Lang.get(par.prefix + '.questions.' + i)
								},
								{
									tag: 'div',
									className: 'toggle'
								}
							]
						},
						{
							tag: 'div',
							className: 'tabContent',
							attr: {
								itemscope: '',
								itemprop: 'acceptedAnswer',
								itemtype: 'https://schema.org/Answer'
							},
							els: [
								formatTextNode(textNode)
							]
						}
					]
				}).append(this.accordion);
			}
		}
	},
	mkE.Base
)